export default {
  fonts: {
    weight: {
      medium: 500
    }
  },
  footer: {
    nav: {
      space: {
        desktop: {
          large: {
            'margin-bottom': '0',
            'padding-bottom': '0'
          },
          medium: {
            'margin-bottom': '0',
            'padding-bottom': '0'
          }
        }
      }
    },
    space: {
      desktop: {
        condensed: {
          'padding-top': '1rem',
          'padding-right': '1.5rem',
          'padding-bottom': '1rem',
          'padding-left': '1.5rem'
        }
      }
    }
  },
  breadcrumb: {
    'separator-icon': {
      space: {'margin-left': '0', 'margin-right': '0'},
      color: '#333333'
    }
  },
  popupMenu: {
    color: {
      icon: {default: 'transparent'}
    }
  },
  accordion: {
    color: {
      background: {
        default: 'white',
        hover: 'white',
        active: 'white',
        focus: 'white'
      }
    }
  },
  pagination: {
    color: {
      border: {separator: 'transparent'}
    }
  },
  forms: {
    common: {
      color: {
        text: {
          disabled: '#333333'
        },
        background: {
          disabled: '#e6e6e6'
        }
      }
    }
  }
}
